import { NewSubTask } from 'shared/types/task';
import * as yup from 'yup';

const schema = yup
  .object<NewSubTask>({
    id: yup.string().required(),
    name: yup.string().required(),
  })
  .strip();

const arraySchema = yup.array().of(schema);

export const newSubTasksValidation = (subTasks: NewSubTask[]) => {
  // drop invalid items individually — validateSync on the full array throws on the first bad item, discarding the valid ones too
  const validSubTasks = subTasks.filter((subTask) =>
    schema.isValidSync(subTask),
  );
  return arraySchema.validateSync(validSubTasks, {
    stripUnknown: true,
  }) as NewSubTask[];
};
